var exports = {
  "k": "xa15a2ab7--dc113c--container",
  "Q": "xa15a2ab7--dc113c--text",
};

module.exports = exports;
